<template>
    <div id="app">
        <nav class="nav">
            <div class="nav-left">
                <div class="nav-item"><span class="is-biggest-font is-serif is-bold is-light-grey">{{this.$name}}</span></div>
            </div>
            <div class="nav-right"></div>
        </nav>
        <main class="content">
            <h1 class="title is-2 is-dark-grey">Access your email quicker for FREE.</h1>
            <h3 class="subtitle is-4 is-light-grey">Your email, right from your desktop.</h3>
            <button id="install" class="button is-large is-success">Continue</button>
        </main>
        <footer class="footer">
            <a class="is-lightest-grey is-smallest-font is-serif is-link is-no-decoration" :href="'//' + this.$host + '/terms'" target="_blank">Terms</a>
            <a class="is-lightest-grey is-smallest-font is-serif is-link is-no-decoration" :href="'//' + this.$host + '/privacy'" target="_blank">Privacy</a>
            <a class="is-lightest-grey is-smallest-font is-serif is-link is-no-decoration" :href="'//' + this.$host + '/home/removeextension'" target="_blank">Uninstall</a>
            <a class="is-lightest-grey is-smallest-font is-serif is-link is-no-decoration" :href="'//' + this.$host + '/home/contactus'" target="_blank">Contact</a>
        </footer>
        <div id="handholding">
            <div id="handholding-wrapper">
                <i class="fas fa-arrow-up" />
                <span>Click "Install" to continue...</span>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        beforeCreate() {
            window.addEventListener("load", function () {
                let deferredPrompt,
                    btnAdd = document.getElementById("install");

                window.addEventListener('beforeinstallprompt', e => {
                    e.preventDefault();
                    deferredPrompt = e;
                });
                btnAdd.addEventListener('click', () => {
                    deferredPrompt.prompt();
                    deferredPrompt.userChoice.then((choiceResult) => this.$impressions.sendEvent('ex_pwa_choice', choiceResult.outcome))
                    document.querySelector(`#handholding`).style.display = 'block';
                });
                window.addEventListener('appinstalled', () => {
                    window.location.replace('/login');
                    this.$gmail.user.signIn();
                });
            });
        }
    }
</script>

<style scoped lang="less">
    body {
        background: linear-gradient(145deg, #ffffff, #d7d7d7);
        height: 100vh;
        width: 100vw;
    }
    .nav {
        position: fixed;
        top:0;
        left:0;
        right:0;
        background-color: transparent;
        box-shadow: none;
    }
    .content {
        position: fixed;
        top:50%;
        left:50%;
        transform: translate(-50%,-50%);
        text-align: center;

        button {
            width: 250px;
        }
    }
    .footer {
        position: fixed;
        bottom:10px;
        left:0;
        right:0;
        text-align: center;

        a {
            margin: 0 10px;
        }
    }
    #handholding {
        display: none;
        position: fixed;
        top:0;
        right:0;
        bottom:0;
        left:0;
        background-color: rgba(0,0,0,0.9);
        z-index: 100000;

        @keyframes arrowBounce {
            0% {
                top:0;
            }
            100% {
                top:-15px;
            }
        }

        #handholding-wrapper {
            position: absolute;
            top:190px;
            right:170px;

            i {
                position: absolute;
                right:0;
                top:0;
                display: block;
                color: #3695ff;
                font-size: 100px;
                animation: arrowBounce 500ms alternate infinite linear;
            }
            span {
                display: block;
                margin-top: 100px;
                text-align: center;
                background-color: #fff;
                font:600 25px "Merriweather","Times New Roman";
                padding: 20px 40px;
                color:#444;
                border-radius: 4px;
            }
        }
    }

</style>
